import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M2.66699 12C2.66699 6.47716 7.14415 2 12.667 2C18.1899 2 22.667 6.47716 22.667 12C22.667 17.5229 18.1899 22 12.667 22C7.14415 22 2.66699 17.5229 2.66699 12Z"
      fill="currentColor"
    />
    <path
      d="M15.9285 10.0114C16.28 9.6599 16.28 9.09005 15.9285 8.73858C15.577 8.38711 15.0072 8.38711 14.6557 8.73858L12.6671 10.7272L10.6785 8.73858C10.327 8.38711 9.75717 8.38711 9.40569 8.73858C9.05422 9.09005 9.05422 9.6599 9.40569 10.0114L11.3943 12L9.40569 13.9886C9.05422 14.3401 9.05422 14.9099 9.40569 15.2614C9.75717 15.6128 10.327 15.6128 10.6785 15.2614L12.6671 13.2728L14.6557 15.2614C15.0072 15.6128 15.577 15.6128 15.9285 15.2614C16.28 14.9099 16.28 14.3401 15.9285 13.9886L13.9399 12L15.9285 10.0114Z"
      fill="#32323B"
    />
  </SvgIcon>
));
